// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from 'unified';
// eslint-disable-next-line import/no-extraneous-dependencies
import visit from 'unist-util-visit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Literal } from 'unist';
import { DateTime } from 'luxon';

import { DEFAULT_DATE_TIME_FORMAT_WITH_TIMEZONE, formatDate } from 'hooks/useFormattedDate';

interface TextNode extends Literal<string> {
  type: 'text';
}

interface Tag {
  tag: string;
  check: (text: string) => boolean;
  replace: (text: string) => string;
}

const currentDateTime: Tag = ((): Tag => {
  const tag = '{{current-date-time}}';

  return {
    tag,
    check: (text: string) => text.includes(tag),
    replace: (text: string): string =>
      text.replace(tag, formatDate(DateTime.now().toISO(), DEFAULT_DATE_TIME_FORMAT_WITH_TIMEZONE)),
  };
})();

const tags = {
  currentDateTime,
} as const;

const traroMarkdown: Plugin & { tags: typeof tags } = () => {
  const tagsArray = Object.keys(tags).reduce((acc, key) => {
    acc.push(tags[key as keyof typeof tags]);

    return acc;
  }, [] as Tag[]);

  return (tree) => {
    visit(tree, 'text', (node: TextNode) => {
      for (const tag of tagsArray) {
        if (tag.check(node.value)) {
          node.value = tag.replace(node.value);
        }
      }
    });
  };
};

traroMarkdown.tags = tags;

export default traroMarkdown;
